// extracted by mini-css-extract-plugin
export var standaloneTable = "_fa-0";
export var standaloneTableWithBodyFill = "_fa-1";
export var withExtraHeader = "_fa-2";